export default function (state = [], action) {
    switch (action.type) {
        case "GET_FAVORITE_QUERIES":
            return action.payload;
            break;
        default:
            return state;
    }
}
